import { c as _c } from "react/compiler-runtime";
import { useRequestError } from '@onefootprint/fetch-hosted/use-request-error';
import { useRequestErrorToast } from '@onefootprint/hooks';
import type { PostHostedOnboardingPrefillChallengeResponse, PrefillPostRequest } from '@onefootprint/request-types';
import { Form, LoadingSpinner } from '@onefootprint/ui';
import type { UseMutationResult } from '@tanstack/react-query';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { getLogger } from '@/idv2/utils/logger';
type EmailPinProps = {
  prefillMutation: UseMutationResult<void, unknown, PrefillPostRequest>;
  challengeData: PostHostedOnboardingPrefillChallengeResponse;
};
type OtpFormData = {
  otp: string;
};
const {
  logError
} = getLogger({
  name: 'idv2',
  location: 'prefill-email-pin'
});
export const EmailPin = t0 => {
  const $ = _c(25);
  const {
    prefillMutation,
    challengeData
  } = t0;
  const showRequestErrorToast = useRequestErrorToast();
  const {
    t
  } = useTranslation("idv2");
  const {
    getErrorCode
  } = useRequestError();
  const methods = useForm();
  let t1;
  if ($[0] !== getErrorCode || $[1] !== methods || $[2] !== prefillMutation.error || $[3] !== t) {
    t1 = () => {
      if (getErrorCode(prefillMutation.error) === "E102") {
        methods.setError("otp", {
          message: t(_temp)
        });
      }
    };
    $[0] = getErrorCode;
    $[1] = methods;
    $[2] = prefillMutation.error;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== prefillMutation.error) {
    t2 = [prefillMutation.error];
    $[5] = prefillMutation.error;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] !== challengeData || $[8] !== prefillMutation || $[9] !== showRequestErrorToast) {
    t3 = async value => {
      ;
      try {
        await prefillMutation.mutateAsync({
          challengeResponse: value,
          challengeToken: challengeData.challengeData.challengeToken
        });
      } catch (t4) {
        const error = t4;
        logError("Failed to fill out pin", error);
        showRequestErrorToast("Something went wrong with the email pin challenge");
      }
    };
    $[7] = challengeData;
    $[8] = prefillMutation;
    $[9] = showRequestErrorToast;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const handleFillOutPin = t3;
  let t4;
  if ($[11] !== t) {
    t4 = t(_temp2);
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t4) {
    t5 = <p className="text-body-2 text-primary">{t4}</p>;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== handleFillOutPin || $[16] !== prefillMutation.isPending) {
    t6 = <Form.Otp name="otp" disabled={prefillMutation.isPending} onComplete={handleFillOutPin} autoFocus={true} />;
    $[15] = handleFillOutPin;
    $[16] = prefillMutation.isPending;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== prefillMutation.isPending) {
    t7 = prefillMutation.isPending && <LoadingSpinner className="min-h-[20px]" />;
    $[18] = prefillMutation.isPending;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== methods || $[21] !== t5 || $[22] !== t6 || $[23] !== t7) {
    t8 = <FormProvider {...methods}>{t5}{t6}{t7}</FormProvider>;
    $[20] = methods;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
};
function _temp($) {
  return $.collectData.prefill.errors.invalidCode;
}
function _temp2($_0) {
  return $_0.collectData.prefill.sentToEmail;
}